import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Translation resources
const resources = {
  EN: {
    translation: {
      HOME: "Home",
      DAY_TOURS: "Day Tours",
      WATER_ACTIVITIES: "Water Activities",
      HOTELS: "Hotels",
      PACKAGES: "Packages",
      ZANZIBAR: "Zanzibar Beach Packages",
      KILIMANJARO: "Mt. Kilimanjaro Packages",
      SAFARI: "Tanzania Safari Packages",
      TRANSFERS: "Transfers",
      CAR_RENTALS: "Car Rentals",
      CONTACT: "Contact",
      ABOUT_US: "About Us",
    },
  },
  ES: {
    translation: {
      HOME: "Inicio",
      DAY_TOURS: "Excursiones de un día",
      WATER_ACTIVITIES: "Actividades acuáticas",
      HOTELS: "Hoteles",
      PACKAGES: "Paquetes",
      ZANZIBAR: "Paquetes de playa en Zanzíbar",
      KILIMANJARO: "Paquetes del Monte Kilimanjaro",
      SAFARI: "Paquetes de safari en Tanzania",
      TRANSFERS: "Traslados",
      CAR_RENTALS: "Alquiler de coches",
      CONTACT: "Contacto",
      ABOUT_US: "Sobre nosotros",
    },
  },
  FR: {
    translation: {
      HOME: "Accueil",
      DAY_TOURS: "Excursions d'une journée",
      WATER_ACTIVITIES: "Activités nautiques",
      HOTELS: "Hôtels",
      PACKAGES: "Forfaits",
      ZANZIBAR: "Forfaits plage Zanzibar",
      KILIMANJARO: "Forfaits Mont Kilimandjaro",
      SAFARI: "Forfaits safari Tanzanie",
      TRANSFERS: "Transferts",
      CAR_RENTALS: "Location de voitures",
      CONTACT: "Contact",
      ABOUT_US: "À propos de nous",
    },
  },
  DE: {
    translation: {
      HOME: "Startseite",
      DAY_TOURS: "Tagestouren",
      WATER_ACTIVITIES: "Wasseraktivitäten",
      HOTELS: "Hotels",
      PACKAGES: "Pakete",
      ZANZIBAR: "Sansibar Strandpakete",
      KILIMANJARO: "Kilimanjaro-Pakete",
      SAFARI: "Tansania Safari-Pakete",
      TRANSFERS: "Transfers",
      CAR_RENTALS: "Mietwagen",
      CONTACT: "Kontakt",
      ABOUT_US: "Über uns",
    },
  },
  ZH: {
    translation: {
      HOME: "首页",
      DAY_TOURS: "一日游",
      WATER_ACTIVITIES: "水上活动",
      HOTELS: "酒店",
      PACKAGES: "套餐",
      ZANZIBAR: "桑给巴尔海滩套餐",
      KILIMANJARO: "乞力马扎罗套餐",
      SAFARI: "坦桑尼亚狩猎套餐",
      TRANSFERS: "接送服务",
      CAR_RENTALS: "租车",
      CONTACT: "联系我们",
      ABOUT_US: "关于我们",
    },
  },
  HI: {
    translation: {
      HOME: "मुखपृष्ठ",
      DAY_TOURS: "दिवसीय पर्यटन",
      WATER_ACTIVITIES: "जल गतिविधियाँ",
      HOTELS: "होटल",
      PACKAGES: "पैकेज",
      ZANZIBAR: "ज़ांज़ीबार बीच पैकेज",
      KILIMANJARO: "किलिमंजारो पैकेज",
      SAFARI: "तंजानिया सफारी पैकेज",
      TRANSFERS: "स्थानांतरण",
      CAR_RENTALS: "कार किराया",
      CONTACT: "संपर्क करें",
      ABOUT_US: "हमारे बारे में",
    },
  },
  AR: {
    translation: {
      HOME: "الرئيسية",
      DAY_TOURS: "الجولات اليومية",
      WATER_ACTIVITIES: "الأنشطة المائية",
      HOTELS: "الفنادق",
      PACKAGES: "الباقات",
      ZANZIBAR: "باقات شاطئ زنجبار",
      KILIMANJARO: "باقات جبل كليمنجارو",
      SAFARI: "باقات سفاري تنزانيا",
      TRANSFERS: "النقل",
      CAR_RENTALS: "تأجير السيارات",
      CONTACT: "اتصل بنا",
      ABOUT_US: "معلومات عنا",
    },
  },
  RU: {
    translation: {
      HOME: "Главная",
      DAY_TOURS: "Однодневные туры",
      WATER_ACTIVITIES: "Водные развлечения",
      HOTELS: "Отели",
      PACKAGES: "Пакеты",
      ZANZIBAR: "Пляжные пакеты Занзибара",
      KILIMANJARO: "Пакеты Килиманджаро",
      SAFARI: "Сафари-пакеты Танзании",
      TRANSFERS: "Трансферы",
      CAR_RENTALS: "Аренда автомобилей",
      CONTACT: "Контакты",
      ABOUT_US: "О нас",
    },
  },
  JA: {
    translation: {
      HOME: "ホーム",
      DAY_TOURS: "日帰りツアー",
      WATER_ACTIVITIES: "ウォーターアクティビティ",
      HOTELS: "ホテル",
      PACKAGES: "パッケージ",
      ZANZIBAR: "ザンジバルビーチパッケージ",
      KILIMANJARO: "キリマンジャロパッケージ",
      SAFARI: "タンザニアサファリパッケージ",
      TRANSFERS: "送迎",
      CAR_RENTALS: "レンタカー",
      CONTACT: "お問い合わせ",
      ABOUT_US: "私たちについて",
    },
  },
  PT: {
    translation: {
      HOME: "Início",
      DAY_TOURS: "Passeios de um dia",
      WATER_ACTIVITIES: "Atividades aquáticas",
      HOTELS: "Hotéis",
      PACKAGES: "Pacotes",
      ZANZIBAR: "Pacotes de praia em Zanzibar",
      KILIMANJARO: "Pacotes do Monte Kilimanjaro",
      SAFARI: "Pacotes de safári na Tanzânia",
      TRANSFERS: "Transferências",
      CAR_RENTALS: "Aluguel de carros",
      CONTACT: "Contato",
      ABOUT_US: "Sobre nós",
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "EN", // default language
  fallbackLng: "EN",
  interpolation: { escapeValue: false },
});

export default i18n;
